"use strict";

var React = require('react');

var BLOG_NAVIGATION_PATH = '/blog/';

function preferDefault(module) {
  return module && module["default"] || module;
}

function isCannotFindModuleError(error) {
  return error.toString().indexOf("Error: Cannot find module") !== -1;
}

function isBlogPathPath(path) {
  return path.includes('blog') && path !== BLOG_NAVIGATION_PATH;
}

var Layout;

try {
  Layout = preferDefault(require(BLOG_LAYOUT_COMPONENT_PATH));
} catch (e) {
  if (isCannotFindModuleError(e)) {
    throw new Error("Couldn't find layout component at \"".concat(BLOG_LAYOUT_COMPONENT_PATH, "\"."));
  }
}

module.exports = function wrapPage(_ref, _ref2) {
  var element = _ref.element,
      props = _ref.props;
  var layoutComponent = _ref2.layoutComponent;
  var path = props.path;

  if (isBlogPathPath(path) && layoutComponent) {
    return /*#__PURE__*/React.createElement(Layout, props, element);
  }
};